<div class="avatar">
  @if (profileAvatar$ | async) {
    <img class="image" src="{{ profileAvatar$ | async }}">
  }
  @if (!(profileAvatar$ | async)) {
    <div class="image"></div>
  }
  <div class="avatar-outline" [ngClass]="{'busy': profileBusy$ | async }">
  </div>
</div>
